import * as React from 'react';
import Place from '@material-ui/icons/PlaceOutlined';
import AccountIcon from '@material-ui/icons/AccountCircleOutlined';
import ExitIcon from '@material-ui/icons/ExitToAppOutlined';
import CloseIcon from '@material-ui/icons/Close';
import { Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, makeStyles, Theme } from '@material-ui/core';
import { Link, useRouteMatch, Redirect } from 'react-router-dom';
import { useStore } from '../../store/StoreProvider';
import { observer } from 'mobx-react';

const useStyles = makeStyles((theme: Theme) => ({
  closeIcon: {
    position: 'absolute',
    right: '4px',
    top: '4px'
  },
  drawer: {
    display: 'none',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  },
  drawerPaper: {
    width: '100%',
    paddingTop: '36px'
  }
}));

const CustomDrawer: React.FC<{ isOpen: boolean, toggle(): void }> = ({ isOpen, toggle }) => {
  const classes = useStyles();
  const { logout, isLoggedIn } = useStore();
  const { url } = useRouteMatch();

  if (!isLoggedIn) {
    return <Redirect to='/login' />
  }

  return (
    <Drawer anchor='left' open={isOpen} className={classes.drawer} PaperProps={{ className: classes.drawerPaper }}>
      <IconButton className={classes.closeIcon} onClick={toggle}>
        <CloseIcon />
      </IconButton>
      <List>
        <ListItem button component={Link} to={`${url}/order`} onClick={toggle}>
          <ListItemIcon>
            <Place />
          </ListItemIcon>
          <ListItemText>Карта</ListItemText>
        </ListItem>
        <ListItem button component={Link} to={`${url}/profile`} onClick={toggle}>
          <ListItemIcon>
            <AccountIcon />
          </ListItemIcon>
          <ListItemText>Профиль</ListItemText>
        </ListItem>
        <ListItem button onClick={logout}>
          <ListItemIcon>
            <ExitIcon />
          </ListItemIcon>
          <ListItemText>Выйти</ListItemText>
        </ListItem>
      </List>
    </Drawer>
  );
};

export default observer(CustomDrawer);